import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../../context/AppContext';
import bgImg from '../../assets/images/bgImg-3.png';

export default function UnsubscribeSuccess() {
  const navigate = useNavigate();
  const { user, language, getNextBillingDate } = useAppContext();

  const nextDate = user?.subscriptions?.length
    ? getNextBillingDate(user.subscriptions[user.subscriptions.length - 1].startDate)
    : null;

  return (
    <main className="min-h-screen bg-gray-50 flex flex-col items-center justify-start pt-12 px-4">
      <div className="w-full max-w-xl mt-12 bg-white p-8 rounded-lg shadow-md text-center">
        <h1 className="text-2xl font-bold text-pink-600 mb-4">Отписка успешна!</h1>
        <p className="text-gray-700 mb-4">Будем рады, если вы захотите вернуться в будущем 🙏</p>

        {nextDate && (
          <p className="text-gray-600 mb-6">
            Доступ в клуб сохранится до <strong>{nextDate.toLocaleDateString('ru-RU')}</strong>
          </p>
        )}

        <button
          onClick={() => navigate('/')}
          className="bg-pink-600 hover:bg-pink-700 font-medium py-2 px-6 rounded-full transition mb-6"
        >
          Вернуться на главную
        </button>

        <div className="bg-pink-50 border border-purple-400 p-4 rounded-md">
          <p className="text-sm text-gray-700 mb-2">
            Если у вас есть минута — расскажите, почему вы решили уйти. Это поможет нам стать лучше.
          </p>
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLScBR_qMTqRkn56lJXRzPhlSHQCBXzEGEINMmiJ_vvQS4lU2Ag/viewform?usp=header"
            target="_blank"
            rel="noopener noreferrer"
            className="text-pink-600 hover:underline text-sm underline"
          >
            Поделиться мнением
          </a>
        </div>
      </div>
    </main>
  );
}